import type { JSX } from "react";
import cn from "classnames";
import { ISkillLevel } from "@/service/review-period";
import { ComparisonMode } from "@/pages/assessment/_components";
import { SkillRatingBar } from "../skill-rating-bar";

interface SkillLevelItemProps {
  skill: ISkillLevel;
  comparisonMode: ComparisonMode;
}

export const SkillLevelItem = ({ skill, comparisonMode }: SkillLevelItemProps): JSX.Element => {
  const expectedValue = comparisonMode === "current" ? skill.expected_level : skill.expected_next_level;

  return (
    <div className="grid grid-cols-[1fr_216px_60px_40px] items-center gap-4 py-1">
      <div className="text-eerie-black flex items-center gap-2 pl-4 text-sm">
        <span>{skill.skill}</span>
      </div>
      <div className="w-full">
        <SkillRatingBar actualValue={skill.actual_level} expectedValue={expectedValue} />
      </div>
      <div className="text-eerie-black text-xs transition-all duration-500 ease-in-out">{expectedValue}</div>
      <div className={cn("text-xs", skill.actual_level >= expectedValue ? "text-green-600" : "text-red-500")}>
        {skill.actual_level}
      </div>
    </div>
  );
};
